import axios from "axios";

export default function getAnalyticsOverview({ dateFrom = "", dateTo = "" }) {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/analytics/overview", {
        params: { date_from: dateFrom, date_to: dateTo },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
